export const shareCardV3TestIds = {
  shareViaEmailButton: 'share-via-email-button',
};
